import {Component, OnInit} from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-consent-question-management',
  templateUrl: './consent-question-management.component.html',
  styleUrls: ['./consent-question-management.component.scss']
})
export class ConsentQuestionManagementComponent implements OnInit {
  consentQuestions: any;
  loadingQuestions: boolean;
  newQuestion: string;

  constructor(private commonService: CommonService, public toastMessagesService: ToastMessagesService, public dialog: MatDialog) {
    this.loadingQuestions = false;
    this.newQuestion = '';
  }

  async ngOnInit() {
    await this.initQuestions();
  }

  async initQuestions() {
    this.loadingQuestions = true;
    try {
      const questionsRequest = await this.commonService.getList('forms/questions');
      this.consentQuestions = questionsRequest.object;
      console.log(this.consentQuestions);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingQuestions = false;
    }
  }

  async deleteQuestion(question) {
    try {
      await this.commonService.deleteItem(`forms/questions?id=${question.id}`);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.initQuestions();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  confirmDeletion(question) {
    const deleteDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Διαγραφή Ερώτησης Συναίνεσης',
        message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την ερώτηση συναίνεσης?',
        icon: 'delete'
      }
    });

    deleteDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.deleteQuestion(question);
      }
    });
  }

  async updateQuestion(question) {
    try {
      question.title = this.newQuestion;
      await this.commonService.updateItem(`forms/questions/`, question);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  async insertQuestion() {
    const value = this.newQuestion;
    if (value.trim() === '') {
      this.toastMessagesService.toastErrorMessage('Θα πρέπει να συμπληρώσετε μια ερώτηση συγκατάθεσης');
      return;
    }

    try {
      await this.commonService.insertItem(`forms/questions`, value);
      this.toastMessagesService.toastMessages('Η εισαγωγή ολοκληρώθηκε με επιτυχία');
      await this.initQuestions();
      this.clearNewQuestion();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }


  clearNewQuestion() {
    this.newQuestion = '';
  }
}
